module.exports = __webpack_public_path__ + "img/location.5bc9be4b.svg";